import { useEffect, useState } from 'react'
import { HeaderMobile } from './HeaderMobile'
import { HeaderDesktop } from './HeaderDesktop'
import { getCookie, setCookie } from 'lib/cookies'
import { Announcement } from './Announcement'

export const Header = ({ menu, mobileMenu, logo, announcement }) => {
  const [bannerClosed, setBannerClosed] = useState(true)

  const closeBanner = () => {
    setBannerClosed(true)
    setCookie('bannerClosed', true)
  }

  useEffect(() => {
    const isClosed = getCookie('bannerClosed') === 'true'
    setBannerClosed(isClosed)
  }, [])

  return (
    <>
      {!bannerClosed && announcement.enabled ? (
        <Announcement {...announcement} closeBanner={closeBanner} />
      ) : null}
      <HeaderDesktop withBanner={!bannerClosed} menu={menu} logo={logo} />
      <HeaderMobile
        withBanner={!bannerClosed}
        menu={menu}
        mobileMenu={mobileMenu}
        logo={logo}
      />
    </>
  )
}
